import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IAsset } from '@rfm/shared-interfaces';
import { BlockUIModule } from 'ng-block-ui';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { CommonComponent } from '../../../../../lib/components/index.mjs';

@Component({
  selector: 'app-asset-card',
  standalone: true,
  imports: [CommonModule, BlockUIModule, CardModule, TableModule, ButtonModule, MenuModule],
  templateUrl: './asset-card.component.html',
  styleUrls: ['./asset-card.component.scss']
})
export class AssetCardComponent extends CommonComponent implements OnInit {

  @Input()
  public assets: IAsset[] = [];
  
  constructor(protected router: Router) {
    super();
  }


  items: MenuItem[] = [
    {
      label: 'View in UISP',
      icon: 'pi pi-file',
      command: () => this.view(this.selectedAsset!.integration!.id!),
    }
  ];

  view(uisp_id: string) {
    window.open(`https://uisp.claddedglass.com/nms/devices#id=${uisp_id}&panelType=device-panel`, '_blank');
  }
  
  ngOnInit() {
  }

      selectedAsset: IAsset | undefined;
    
      rowSelected()
      {
        console.log("Asset", this.selectedAsset);
        this.router.navigate(['/admin/customers/view/', this.selectedAsset?.id]);
      }
  

}
